// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemNotFound_wrapper__1OSnZ"};